<div class="content">
    <h3 class="h3">Chính Sách Của Công Ty</h3>
    <!-- Nav pills -->
    <ul class="nav" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-toggle="pill" href="#delivery">Vận Chuyển & Thanh Toán</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="pill" href="#warranty">Bảo Hành & Đổi Trả</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="pill" href="#security">Bảo Mật Thông Tin</a>
        </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content">
        <div id="delivery" class="container tab-pane active">
            <div id="news_id">
                <h2>Chính Sách Vận Chuyển và Hình Thức Thanh Toán</h2>
                <div>
                    <br>
                    <h3>I - Chính Sách Vận Chuyển và Giao Hàng</h3>
                    <br>
                    <p>
                        <span>&nbsp; &nbsp;- Miễn phí vận chuyển ống nhựa và phụ kiện đến chân công trình và dự án trên địa bàn Toàn Quốc</span>
                    </p>
                    <p>
                        <span>&nbsp; &nbsp;- Chất lượng hàng hóa : Hàng mới 100% được quy định theo tiêu chuẩn của nhà sản xuất </span>
                    </p>
                    <p>
                        <span>&nbsp; &nbsp;- Bên B (Công Ty TNHH TM Bích Vân) có trách nhiệm vận chuyển hàng tới chân công trình bên A (Quý khách hàng )-tới vị trí mà xe có thể vào được, nếu xe không thể vào được bên A có trách nhiệm tìm địa điểm gần nhất để xuống hàng giải phóng xe. Bên B có trách nhiệm giao đầy đủ Hoá đơn tài chính (VAT) theo quy định và Giấy chứng nhận chất lượng sản phẩm cho bên A.</span>
                    </p>
                    <p>
                        <span>&nbsp; &nbsp;- Bên B bốc hàng lên xe, bên A bốc hàng xuống xe.</span>
                    </p>
                    <p>
                        <span>&nbsp; &nbsp;- Khi nhận hàng, bên mua có trách nhiệm kiểm nhận phẩm chất, qui cách hàng hóa tại chỗ. Nếu phát hiện hàng thiếu hoặc không đúng tiêu chuẩn chất lượng v.v… thì lập biên bản tại chỗ yêu cầu bên bán xác nhận. &nbsp; &nbsp;</span>
                    </p>
                    <p>
                        <span>&nbsp; &nbsp;- Địa điểm và thời gian giao hàng (thỏa thuận khi ký hợp đồng)</span>
                    </p>
                    <br>
                    <h3>II - Hình Thức Thanh Toán</h3>
                    <br>
                    <p>
                        <span>- Tiền mặt</span>
                    </p>
                    <p>
                        <span>- Chuyển Khoản :</span>
                    </p>
                    <p>
                        <span>Công Ty TNHH Thương Mại Bích Vân</span>
                    </p>
                    <p>
                        <span>Đại diện: Bà Nguyễn Thị Bích Vân</span>
                    </p>
                    <p>
                        <span>Tài khoản số : 102010000434827</span>
                    </p>
                    <p>
                        <span>tại Ngân hàng Công Thương Lê Chân Hải Phòng</span>
                    </p>
                    <p>
                        <span>* Danh mục các Tài Khoản đã đăng ký thuế:</span>
                    </p>
                    <br>
                    <h3>III - Phương Thức Thanh Toán</h3>
                    <br>
                    <p>- Thanh toán 100% trước khi giao hàng
                    </p>
                    <p>Bảo lãnh thực hiện hợp đồng( bảo lãnh ngân hàng ) theo yêu cầu của Quý Khách
                    </p>
                    <p style="text-align: justify; padding-bottom: 0px; line-height: 20px; margin: 0px; padding-left: 0px; padding-right: 0px; font-family: arial; color: rgb(67,67,67); padding-top: 0px">
                        &nbsp;</p>
                    <p style="text-align: justify; padding-bottom: 0px; line-height: 20px; margin: 0px; padding-left: 0px; padding-right: 0px; font-family: arial; color: rgb(67,67,67); padding-top: 0px">
                        &nbsp;</p>
                    <p style="text-align: justify; padding-bottom: 0px; line-height: 20px; margin: 0px; padding-left: 0px; padding-right: 0px; font-family: arial; color: rgb(67,67,67); padding-top: 0px">
                        &nbsp;</p>
                </div>
            </div>
        </div>
        <div id="warranty" class="container tab-pane fade">
            <div id="news_id">
                <h2>Chính Sách Bảo Hành và Đổi-Trả Hàng Hóa</h2>
                <div id="news_detail">
                    <br>
                    <h3>I - CHÍNH SÁCH BẢO HÀNH – BẢO TRÌ</h3>
                    <br>
                    <table border="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td>
                                    <p>
                                        <span>- Công Ty chúng tôi chịu trách nhiệm bảo hành miễn phí trong thời hạn 12 tháng kể từ ngày bàn giao hàng hóa nếu các hư hỏng thuộc lỗi nhà sản xuất. </span>
                                    </p>
                                    <p>
                                        <span> Các hư hỏng do lỗi nhà sản xuất này sẽ được bảo hành theo chính sách bảo hành của nhà sản xuất</span>
                                    </p>
                                    <p>
                                        <span>* Quý khách có trách nhiệm lắp đặt và bảo quản hàng hóa theo đúng tài liệu kỹ thuật kèm theo của nhà sản xuất&nbsp;</span>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <h3>II - CHÍNH SÁCH ĐỔI, TRẢ LẠI HÀNG</h3>
                    <br>
                    <table border="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td>
                                    &nbsp;</td>
                                <td>
                                    <p>
                                        <span>- Trong trường hợp Công ty chúng tôi giao hàng không đáp ứng đúng các yêu cầu của Quý Khách về kỹ thuật, chủng loại, số lượng. Chúng tôi có trách nhiệm đổi, trả hàng cho quý khách và chịu mọi chi phí đổi trả hàng này.</span>
                                    </p>
                                    <p>
                                        <span>- Khi kết thúc công trình Quý khách được trả lại các sản phẩm chưa sử dụng với điều kiện sản phẩm còn mới 100% chưa qua sử dụng (nguyên vẹn không trày xước, biến dạng, sai hỏng) với đơn giá tại thời điểm trả hàng, được áp dụng theo quy định hiện hành của nhà sản xuất.</span>
                                    </p>
                                    <p>
                                        <span>- Với những hàng đặc chủng, sản xuất theo đơn đặt hàng (sản xuất theo yêu cầu) sẽ không được trả lại.</span>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div id="security" class="container tab-pane fade">
            <div id="news_id">
                <h2>Chính Sách Bảo Mật Thông Tin</h2>
                <div id="news_detail">
                    <br>
                    <h3>I - Mục đích và phạm vi thu thập thông tin</h3>
                    <br>
                    <p>
                        <span>Thuật ngữ “Thông tin cá nhân” trong Chính Sách này nghĩa là thông tin nhận diện hoặc có khả năng nhận diện danh tính cá nhân của khách hàng. Những loại thông tin cá nhân mà chúng tôi xử lý (có thể khác nhau theo phạm vi quyền hạn dựa trên luật pháp hiện hành) bao gồm:</span>
                    </p>
                    <p>
                        <span>Tên công ty, cửa hàng, đơn vị kinh doanh, địa chỉ giao dịch, mã số thuế</span>
                    </p>
                    <p>
                        <span>Họ Tên, địa chỉ liên lạc</span>
                    </p>
                    <p>
                        <span>Email, số điện thoại di động, số điện thoại bàn</span>
                    </p>
                    <p>
                        <span>Chúng tôi luôn thông báo cho khách hàng biết về mục đích cụ thể nếu cần thu thập những thông tin cá nhân của khách hàng trên trang web này, và mọi thông tin đều phải được &nbsp;khách hàng tự nguyện cung cấp.</span>
                    </p>
                    <br>
                    <h3>II - Phạm vi sử dụng thông tin</h3>
                    <br>
                    <p>
                        <span>Thông tin cá nhân thu thập được sẽ chỉ được sử dụng trong nội bộ công ty. Bichvan.vn có thể công bố các thông tin cá nhân thu thập từ khách hàng cho bên thứ ba, như các đại lý của chúng tôi, các nhà cung cấp dịch vụ khác nhằm cung cấp dịch vụ tốt nhất cho khách hàng.</span>
                    </p>
                    <p>
                        <span>Khi cần thiết, chúng tôi có thể sử dụng những thông tin này để liên hệ trực tiếp với khách hàng dưới các hình thức như: gửi thư ngỏ, đơn đặt hàng, thư cảm ơn, thông tin về khuyến mãi và dịch vụ mới…</span>
                    </p>
                    <p>
                        <span>Bichvan.vn sẽ nỗ lực để đảm bảo rằng các nhân viên, cán bộ, đại lý, tư vấn hoặc bên thứ ba nào được đề cập ở trên có liên quan đến việc thu thập và xử lý thông tin khách hàng sẽ nhận thức và thấu hiểu Chính sách bảo mật này.</span>
                    </p>
                    <br>
                    <h3>III - Thời gian lưu trữ thông tin</h3>
                    <br>
                    <p>
                        <span>Bichvan.vn sẽ lưu trữ các thông tin cá nhân do khách hàng cung cấp trên các hệ thống nội bộ của chúng tôi trong quá trình cung cấp dịch vụ cho khách hàng hoặc cho đến khi hoàn thành mục đích thu thập hoặc khi khách hàng có yêu cầu hủy các thông tin đã cung cấp.</span>
                    </p>
                    <br>
                    <h3>IV - Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân</h3>
                    <br>
                    <p>
                        <span>Công Ty TNHH TM Bích Vân</span>
                    </p>
                    <p>
                        <span>Số 237 Hai Bà Trưng, Q.Lê Chân, TP. Hải Phòng</span>
                    </p>
                    <p>
                        <span>0313 950 063</span>
                    </p>
                    <br>
                    <h3>V - Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu cá nhân của mình.</h3>
                    <br>
                    <p>
                        <span>Khách hàng muốn chỉnh sửa thông tin cá nhân của mình vui lòng liên hệ bộ phận chăm sóc khách hàng của Bichvan.vn theo số hotline: &nbsp;0906 066 757</span>
                    </p>
                    <br>
                    <h3>VI - Cam kết bảo mật thông tin cá nhân khách hàng</h3>
                    <br>
                    <p>
                        <span>Bichvan.vn sẽ không chia sẻ thông tin của quý khách cho bất kỳ một công ty nào khác ngoại trừ các đại lý, các nhà cung cấp có liên quan đến việc cung cấp dịch vụ cho khách hàng. Trong một vài trường hợp đặc biệt, Bichvan.vn có thể bị yêu cầu phải tiết lộ thông tin cá nhân, ví dụ như khi có căn cứ cho việc tiết lộ thông tin là cần thiết để ngăn chặn các mối đe dọa về tính mạng và sức khỏe, hay cho mục đích thực thi pháp luật. Bichvan.vn cam kết tuân thủ Đạo luật Bảo Mật và các Nguyên tắc Bảo mật Quốc gia.</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>